import type { RefCallback } from "react"
import { useCallback, useRef, useState } from "react"

export function useHover<T extends HTMLElement = HTMLElement>(): {
    isHovered: boolean
    hoverRef: RefCallback<T>
} {
    const [isHovered, setIsHovered] = useState(false)

    const nodeRef = useRef<T | null>(null)

    const handleRef: RefCallback<T> = useCallback((node) => {
        if (nodeRef.current) {
            nodeRef.current.removeEventListener("mouseenter", enter)
            nodeRef.current.removeEventListener("mouseleave", leave)
        }

        if (node) {
            node.addEventListener("mouseenter", enter)
            node.addEventListener("mouseleave", leave)
        }

        nodeRef.current = node
    }, [])

    const enter = () => setIsHovered(true)
    const leave = () => setIsHovered(false)

    return { isHovered, hoverRef: handleRef }
}
